<template>
  <div v-if="time.length>=2">
    <div>
      <div class="flex-container">
        <span class="name-right">{{ time[0] }}</span>
        <span class="time-left" v-if="scope.type !== 'reminder'">:{{scope.time[time[0]]}}</span>
        <span class="time-left" v-if="scope.type === 'reminder'">:{{scope.time[time[0]]?'已完成':'未完成'}}</span>
        <el-tooltip content="折叠更多" v-if="showToolTip[scope.index]">
          <i class="el-icon-caret-top iconMore" @click="openMore(scope.index)">折叠更多</i>
        </el-tooltip>
        <el-tooltip content="展开更多" v-if="!showToolTip[scope.index]">
          <i class="el-icon-caret-bottom iconMore" @click="openMore(scope.index)">展开更多</i>
        </el-tooltip>
      </div>
      <div v-for="(con,index1) in time" :key="index1" v-if="showToolTip[scope.index]">
        <br v-if="index1 !== 0 && scope.type === 'reminder'">
        <div v-if="index1 !== 0" class="flex-container">
          <span class="name-right">{{ con }}</span>
          <span class="time-left" v-if="scope.type !== 'reminder'">:{{scope.time[con]}}</span>
          <span class="time-left" v-if="scope.type === 'reminder'">:{{scope.time[con]?'已完成':'未完成'}}</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="time.length>0 && time.length<2">
    <div v-if="scope.type === 'reminder'">
      {{ time[0] }}:{{scope.time[time[0]]?'已完成':'未完成'}}
    </div>
    <div v-else>
      {{ time[0] }}:{{scope.time[time[0]]}}
    </div>
  </div>
</template>

<script>
export default {
  name: "ExFoldForm",
  props: ['scope'],
  data() {
    return {
      showToolTip: [],
      time:[]
    }
  },
  watch:{
    'scope':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
         this.time = Object.keys(newVal.time)
        }
      },
      immediate:true,
      deep:true
    }
  },
  methods: {
    openMore(index) {
      this.$set(this.showToolTip, index, !this.showToolTip[index]);
    }
  }
}
</script>

<style scoped>
.iconMore {
  color: #4eaad4;
  cursor: pointer;
}
.flex-container {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  max-width: 600px; /* 根据需要调整最大宽度 */
  margin: 0 auto; /* 居中整个容器 */
}

.name-right {
  text-align: right; /* 右对齐名称部分 */
  min-width: 100px; /* 最小宽度，防止名称过短时布局错乱 */
  max-width: 200px; /* 最大宽度，防止名称过长时占据过多空间 */
  margin-right: 10px; /* 可选：添加右侧间距 */
}

.time-left {
  text-align: left; /* 左对齐时间部分 */
}
</style>
